import { useRef, useState } from "react";
import { Bold, Italic, Heading, List, Code, Eye, Pencil } from "lucide-react";
import { Markdown } from "@/components/Markdown";

const tools = [
  { icon: Heading, label: "Heading", wrap: ["## ", ""], testid: "md-heading" },
  { icon: Bold, label: "Bold", wrap: ["**", "**"], testid: "md-bold" },
  { icon: Italic, label: "Italic", wrap: ["_", "_"], testid: "md-italic" },
  { icon: List, label: "List", wrap: ["- ", ""], testid: "md-list" },
  { icon: Code, label: "Code", wrap: ["`", "`"], testid: "md-code" },
];

export function MarkdownEditor({ value, onChange, placeholder, rows = 4, testid }) {
  const ref = useRef(null);
  const [preview, setPreview] = useState(false);

  const apply = (before, after) => {
    const el = ref.current;
    if (!el) return;
    const start = el.selectionStart;
    const end = el.selectionEnd;
    const sel = value.slice(start, end);
    const next = value.slice(0, start) + before + (sel || "text") + after + value.slice(end);
    onChange(next);
    setTimeout(() => {
      el.focus();
      el.selectionStart = start + before.length;
      el.selectionEnd = start + before.length + (sel || "text").length;
    }, 0);
  };

  return (
    <div>
      <div className="flex items-center justify-between border-b border-border pb-2 mb-2">
        <div className="flex items-center gap-1">
          {tools.map((t) => (
            <button key={t.label} type="button" title={t.label} data-testid={t.testid}
              onClick={() => apply(t.wrap[0], t.wrap[1])}
              className="p-1.5 text-muted-foreground hover:text-foreground hover:bg-secondary/50 transition-colors">
              <t.icon size={15} />
            </button>
          ))}
        </div>
        <button type="button" onClick={() => setPreview((v) => !v)} data-testid="md-preview-toggle"
          className="inline-flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground px-2 py-1">
          {preview ? <><Pencil size={13} /> Write</> : <><Eye size={13} /> Preview</>}
        </button>
      </div>
      {preview ? (
        <div className="min-h-[6rem] text-sm px-1">
          {value ? <Markdown>{value}</Markdown> : <span className="text-muted-foreground text-sm">Nothing to preview</span>}
        </div>
      ) : (
        <textarea
          ref={ref}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          rows={rows}
          data-testid={testid}
          className="w-full bg-transparent resize-none outline-none text-sm placeholder:text-muted-foreground font-sans leading-relaxed"
        />
      )}
    </div>
  );
}
